import { PaymentNotes } from '@avantstay/arriere-clients/dist/arriereBackoffice'
import { capitalizeEachFirstLetter } from '@avantstay/backoffice-core'

import {
  BookingAcquisitionView,
  BookingBackToBackView,
  BookingRepeatView,
} from '@new/__global/components/Filters/Filters.types'

export const backToBackFilterOptions = [
  {
    title: 'Yes',
    value: BookingBackToBackView.b2b,
    id: BookingBackToBackView.b2b as string,
  },
  {
    title: 'No',
    value: BookingBackToBackView.nonB2b,
    id: BookingBackToBackView.nonB2b as string,
  },
]

export const acquisitionFilterOptions = Object.keys(BookingAcquisitionView).map(listItem => ({
  value: BookingAcquisitionView[listItem as keyof typeof BookingAcquisitionView],
  title: capitalizeEachFirstLetter(
    BookingAcquisitionView[listItem as keyof typeof BookingAcquisitionView].replace(/_/g, ' '),
  ),
  id: BookingAcquisitionView[listItem as keyof typeof BookingAcquisitionView],
}))

export const repeatFilterOptions = Object.keys(BookingRepeatView).map(listItem => ({
  value: BookingRepeatView[listItem as keyof typeof BookingRepeatView],
  title: capitalizeEachFirstLetter(
    BookingRepeatView[listItem as keyof typeof BookingRepeatView].replace(/_/g, ' '),
  ),
  id: BookingRepeatView[listItem as keyof typeof BookingRepeatView],
}))

export const paymentAuditNotesFilterOptions = Object.keys(PaymentNotes).map(listItem => ({
  value: PaymentNotes[listItem as keyof typeof PaymentNotes],
  title: capitalizeEachFirstLetter(
    PaymentNotes[listItem as keyof typeof PaymentNotes].replace(/_/g, ' '),
  ),
  id: PaymentNotes[listItem as keyof typeof PaymentNotes],
}))

export const paymentPlanFilterOptions = [
  {
    value: 'yes',
    title: 'Yes',
    id: 'Yes',
  },
  {
    value: 'no',
    title: 'No',
    id: 'No',
  },
]
